<template>
  <div class="mx-2">
    <div
      class="d-flex justify-content align-items-center mb-1 cursor-pointer mt-2"
      @click="goBackToList()">
      <button
        class="btn btn-sm rounded-circle p-25"
        :class="isDark ? 'btn-danger' : 'btn-primary'">
        <i class="feather icon-arrow-left arrow-icon"></i>
      </button>
      <div class="ml-1 text-capitalize text-dark goback-text">
        {{ $t("actions.go_back") }}
      </div>
    </div>
      <div class="row p-1">
        <div v-if="form.trainingValidations.length" class="col-4">
          <div class="history-card card">
            <div class="history-header d-flex align-items-center justify-content-between">
              <strong>{{ $t('custom_forms.history') }}</strong>
              <small class="text-muted">
                {{ form.trainingValidations.length }}
                {{ $t('custom_forms.entries') }}
              </small>
            </div>

            <div class="history-table">
              <div class="history-row history-row--head bg-transparent">
                <div class="col-state text-body">{{ $t('custom_forms.state') }}</div>
                <div class="col-user text-body">{{ $t('custom_forms.user') }}</div>
                <div class="col-date text-body">{{ $t('custom_forms.date') }}</div>
              </div>

              <div
                v-for="s in form.trainingValidations"
                :key="s.id"
                class="history-row-item-container">
                <div class="history-row-item">
                  <div class="col-state">
                    <b-badge pill :variant="getStatusVariant(s.status.name)" class="history-badge">
                      {{ getStatusLabel(s.status.name) }}
                    </b-badge>
                  </div>
                  <div class="col-user">
                    <div class="history-user" :title="formatUser(s)">
                      <div class="user-name text-body">{{ getUserName(s) || '—' }}</div>
                      <div v-if="getUserEmail(s)" class="user-email text-body">
                        {{ getUserEmail(s) }}
                      </div>
                    </div>
                  </div>
                  <div class="col-date">
                    <small class="history-date text-body">
                      {{ formatDate(s.approved_at || s.rejected_at || s.reopened_at || s.created_at) }}
                    </small>
                  </div>
                </div>
                <div class="history-row-item__comments">
                  {{ s.comments || s.reopened_comments }}
                </div>
              </div>
            </div>
            <!-- <div class="text-muted small py-1">
              {{ $t('custom_forms.empty') }}
            </div> -->
          </div>
        </div>
        <div :class="form.trainingValidations.length ? 'col-8 form-container' : 'col-12'">
          <b-card no-body>
            <div class="mt-2">
              <h4 class="mb-2 ml-1">{{ $t("training.title") }}</h4>
            </div>
            <div class="header-grid mb-1 ml-2">
              <div class="info-card">
                <div class="info-row">
                  <span class="info-label">{{ $t("risk.reference_number") }}:</span>
                  <span class="info-value">{{ referenceShowed }}</span>
                </div>
              </div>
            </div>

            <b-form-group
              class="labelForSelect mx-1"
              label="Región"
            >
              <v-select
                class="w-100"
                v-model="form.id_sector"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="sectorOptions"
                :reduce="(val) => val.value"
                append-to-body
                :disabled="isFormDisabled"
              />
              <span v-if="errors.id_sector" class="text-error">
                {{ errors.id_sector }}
              </span>
            </b-form-group>

             <b-form-group
              class="labelForSelect mx-1"
              label="División"
            >
              <v-select
                class="w-100"
                v-model="form.id_center"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="centerOptions"
                :reduce="(val) => val.value"
                append-to-body
                :disabled="isFormDisabled"
              />
              <span v-if="errors.id_center" class="text-error">
                {{ errors.id_center }}
              </span>
            </b-form-group>

             <b-form-group
              class="labelForSelect mx-1"
              label="Estado"
            >
              <v-select
                class="w-100"
                v-model="form.id_region"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="regionOptions"
                :reduce="(val) => val.value"
                append-to-body
                :disabled="isFormDisabled"
              />
              <span v-if="errors.id_region" class="text-error">
                {{ errors.id_region }}
              </span>
            </b-form-group>

          <!-- <b-form-group
            class="labelForSelect ml-1"
            label="Inmueble"
          >
            <v-select
              v-model="currentFacilitySelected"
              :options="formattedFacilityOptions"
              :filterable="false"
              :multiple="false"
              :clearable="false"
              ref="selectable"
              @search="onSearchFacility"
              class="w-100"
              :disabled="isFormDisabled"
              @input="onChangeFacilitySelect"
            />
          </b-form-group> -->

            <b-form-group
              class="labelForSelect mx-1"
              label="Fecha de capacitación"
            >
              <flat-pickr
                id="date"
                v-model="form.registration_date"
                :config="datePickerConfig"
                :disabled="isFormDisabled"
                class="timeNoBackground w-100"
                :input-attributes="{ autocomplete: 'off' }"
              />
              <span v-if="errors.date" class="text-error">
                {{ errors.registration_date }}
              </span>
            </b-form-group>

            <b-form-group
              class="labelForSelect mx-1"
              label="Tipo Capacitación"
            >
              <v-select
                v-model="form.training_type"
                :options="typeTrainingOptions"
                :filterable="false"
                :multiple="false"
                :clearable="true"
                class="w-100"
                :disabled="isFormDisabled"
              />
              <span v-if="errors.training_type" class="text-error">
                {{ errors.training_type }}
              </span>
            </b-form-group>

            <b-form-group
              class="labelForSelect mx-1"
              label="Modalidad Capacitación"
            >
              <v-select
                v-model="form.training_modality"
                :options="trainingModalityOptions"
                :filterable="false"
                :multiple="false"
                :clearable="true"
                class="w-100"
                :disabled="isFormDisabled"
              />
              <span v-if="errors.training_modality" class="text-error">
                {{ errors.training_modality }}
              </span>
            </b-form-group>

            <b-form-group
              class="labelForSelect mx-1"
              label="Temática Capacitación"
            >
              <v-select
                v-model="form.training_topic"
                :options="trainingTopicsOptions"
                :filterable="false"
                :multiple="false"
                :clearable="true"
                class="w-100"
                :disabled="isFormDisabled"
              />
              <span v-if="errors.training_topic" class="text-error">
                {{ errors.training_topic }}
              </span>
            </b-form-group>

            <b-form-group
              class="labelForSelect mx-1"
              label="Descripción Capacitación"
            >
              <b-form-textarea
                rows="3"
                max-rows="6"
                v-model="form.description_training"
                :disabled="isFormDisabled"
              ></b-form-textarea>
              <span v-if="errors.description_training" class="text-error">
                {{ errors.description_training }}
              </span>
            </b-form-group>

            <b-form-group
              class="mx-1"
              label="Participantes (REMS)"
            >
              <div v-if="form.participants.length" class="table-responsive">
                <b-alert
                  v-if="form.participants.length > 30"
                  show
                  variant="warning"
                  class="p-1 "
                >
                  Solo se pueden agregar 30 rems a la capacitación
                </b-alert>
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th >REMS</th>
                      <th>Nommbre del Inmueble</th>
                      <th>Cantidad de participantes</th>
                      <th style="width: 100px;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(participant, index) in form.participants" :key="'participants'+index">
                      <td>
                        {{ index + 1 }}
                      </td>
                      <td class="text-center">
                        <v-select
                          label="rems"
                          v-model="participant.rems"
                          :options="formattedFacilityOptions"
                          :filterable="false"
                          :multiple="false"
                          :clearable="false"
                          @search="onSearchFacility"
                          :disabled="isFormDisabled"
                          @input="onChangeFacilitySelect($event, index)"
                          append-to-body
                        >
                          <template #no-options>
                            No hay resultados disponibles
                          </template>
                          <template v-slot:option="option">
                            {{ option.rems }} - {{ option.description }}
                          </template>
                        </v-select>
                      </td>
                      <td>
                        {{ participant.name }}
                      </td>
                      <td class="d-flex align-items-center">
                        <b-form-input
                          type="number"
                          autocomplete="off"
                          :disabled="isFormDisabled || (!participant.rems)"
                          v-model="participant.number_of_participants"

                        />
                      </td>
                      <td>
                        <b-button
                          v-if="!isFormDisabled"
                          size="sm"
                          variant="outline-danger"
                          class="ml-1"
                          :disabled="isFormDisabled"
                          @click="removeParticipant(index)"
                        >
                          {{ $t("actions.delete") }}
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <b-alert v-else show variant="warning" class="p-1 mb-0">
                No se han agregado participantes
              </b-alert>
              <b-button
                v-if="!isFormDisabled && (form.participants.length < 30)"
                @click="addNewParticipant"
                size="sm"
                variant="outline-info mt-1"
                :disabled="isFormDisabled"
              >
                + REMS
              </b-button>
              <div v-if="errors.participants" class="text-error">
                {{ errors.participants }}
              </div>
            </b-form-group>

            <b-form-group
              class="labelForSelect mx-1"
              label="Agregar documentos adjuntos"
            >
              <div class="upload-button-container flex-column align-items-start">
                <b-button
                  variant="primary"
                  size="sm"
                  :disabled="isFormDisabled"
                  class="upload-button mb-1 cursor-pointer"
                >
                  <feather-icon icon="UploadIcon" size="18" class="cursor-pointer"/>
                  <input
                    id="filesForPenetrationsTest"
                    type="file"
                    multiple
                    :disabled="isFormDisabled"
                    class="file-input cursor-pointer"
                    @change="handleFileChange"
                  />
                </b-button>
                <div class="d-flex mb-1">
                  <div
                    v-for="(file, index) in files"
                    :key="'files-' + index"
                    class="preview-container"
                  >
                    <div class="preview-content">
                      <feather-icon
                        icon="FileTextIcon"
                        size="70"
                      />
                      <button
                        @click="removeFile(index)"
                        class="remove-button"
                        :disabled="isFormDisabled"
                      >
                        &#10005;
                      </button>
                    </div>
                    <span>{{ file.name }}</span>
                  </div>
                  <template v-if="showExistingFilesEdit">
                    <div
                      v-for="(file, index) in existingFiles"
                      :key="'existing-' + index"
                      class="preview-container"
                    >
                      <div class="preview-content">
                        <feather-icon
                          icon="FileTextIcon"
                          size="70"
                        />
                        <button
                          @click="removeExistingFile(index)"
                          class="remove-button"
                          :disabled="isFormDisabled"
                        >
                          &#10005;
                        </button>
                      </div>
                      <div class="text-center">
                        <a :href="file.url" download>
                          {{ file.name }}
                        </a>
                      </div>
                    </div>
                  </template>
                </div>
                <span v-if="errors.attachedDocuments" class="text-error">
                  {{ errors.attachedDocuments }}
                </span>
              </div>
            </b-form-group>

            <b-form-group
              v-if="showExistingFiles"
              :label="$t('testing.existingFiles')"
              class="ml-1"
            >
              <div class="row">
                <div class="col-6">
                  <b-list-group>
                    <b-list-group-item
                      v-for="(file, index) in existingFiles"
                      :key="'existing-' + index"
                      class="d-flex justify-content-between align-items-center"
                    >
                      {{ file.name }}
                      <a :href="file.url" download>
                        <feather-icon
                          icon="DownloadCloudIcon"
                          size="18"
                        />
                      </a>
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </div>
            </b-form-group>

            <div class="" v-if="showSaveButton">
              <b-button
                @click="submitForm"
                variant="info"
                class="ml-1 mb-2"
                :disabled="isFormDisabled || disabledButton"
              >
                {{ $t("actions.save") }}
              </b-button>
            </div>

            <div class="px-2" v-if="canUserSendToReopen">
              <v-select
                v-model="userSelectedReasigned"
                :options="userReopenedOptions"
                :placeholder="$t('custom_forms.assigned_to_reopen')"
                :reduce="(user) => user.id"
                label="full_name"
                class="comment-box mb-1"
              >
                <template v-slot:option="option">
                  {{ option.user }} - {{ option.full_name }}
                </template>
              </v-select>
              <b-button
                variant="warning"
                class="ml-auto mb-3"
                :disabled="!userSelectedReasigned || disabledButton"
                @click="reopen()"
              >
                {{ $t("testing.reopenTest") }}
              </b-button>
            </div>

            <div class="px-2" v-if="canUserSendToReview">
              <v-select
                v-model="userSelected"
                :options="userOptions"
                :placeholder="$t('custom_forms.assigned_to')"
                :reduce="(user) => user.id"
                class="comment-box mb-1"
                :filter-by="filterUsers"
                :get-option-label="getUserLabel"
              >
                <template v-slot:option="option">
                  {{ option.user }} - {{ option.full_name }}
                </template>
              </v-select>
              <b-button
                variant="warning"
                class="ml-auto mb-3"
                :disabled="!userSelected || disabledButton"
                @click="sendToReview()"
              >
                {{ $t("custom_forms.send_to_review") }}
              </b-button>
            </div>

            <div v-if="showValidateButtons" class="mb-1 px-2">
              <b-form-group
                class="text-capitalize"
                :label="$t('custom_forms.review_comments')"
                label-for="validation_comment"
              >
                <b-form-textarea
                  class="comment-box"
                  id="validation_comment"
                  v-model="validationComment"
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
                <span v-if="errorValidationComment" class="text-error">
                  {{ errorValidationComment }}
                </span>
              </b-form-group>
              <div class="d-flex">
                <b-button
                  variant="success"
                  class="mr-1"
                  :disabled="disabledButton"
                  @click="approve()"
                >
                  {{ $t("actions.approve") }}
                </b-button>
                <div
                  class="d-flex"
                >
                  <b-button
                    variant="danger"
                    :disabled="disabledButton"
                    @click="reject()"
                  >
                    {{ $t("actions.reject") }}
                  </b-button>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
  </div>
</template>
<script>
import { computed,getCurrentInstance,onMounted } from "@vue/composition-api";
import { useTrainingForm } from './trainingForm';
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import unit from "@/store/unit";

export default {
  name: "TrainingForm",
  components: {
    vSelect,
    flatPickr
  },
  props: {
    dataToEdit: {
      default: null,
    },
    centerOptions: {
      type: Array
    },
    sectorOptions: {
      type: Array,
    },
    regionOptions: {
      type: Array,
    }
  },
  setup(props, { emit, root }) {
    const vm = getCurrentInstance().proxy;

    const {
      form,
      isDark,
      formattedFacilityOptions,
      isFormDisabled,
      validationComment,
      referenceShowed,
      datePickerConfig,
      resultsOptions,
      existingFiles,
      typeTrainingOptions,
      trainingModalityOptions,
      trainingTopicsOptions,
      formStatus,
      canUserSendToReview,
      eventTypeOptions,
      errors,
      userOptions,
      userSelected,
      files,
      currentFacilitySelected,
      onSearchFacility,
      formattedUserOptions,
      goBackToList,
      fetchFacilityData,
      addNewParticipant,
      removeParticipant,
      onChangeFacilitySelect,
      handleFileChange,
      removeFile,
      submitForm,
      setEditData,
      removeExistingFile,
      getValidators,
      sendToReview,
      approve,
      reject,
      showAlert,
      userReopenedOptions,
      reopen,
      errorValidationComment,
      onSearchByRems,
      getUsers,
      onSearchUser,
      getStatusVariant,
      getStatusLabel,
      formatUser,
      getUserName,
      getUserEmail,
      formatDate,
      user,
      formId,
      disabledButton,
      userSelectedReasigned,
      getUsersReopened
    } = useTrainingForm(emit)

    onMounted(async () => {
      await getValidators();
      await getUsersReopened();
      /* fetchFacilityData()
      getUsers() */
      if(props.dataToEdit) {
        setEditData(props.dataToEdit)
      }
    });

    //COMPUTED
    const canUserSendToReopen = computed(() => {
      const userCanReopenPm =  vm.$can('reopen_pm', 'Trainings');

      if (userCanReopenPm) {
        const conditionPmForm = (formStatus.value.inProgress || formStatus.value.isReview || formStatus.value.isReopen || formStatus.value.isRejected);

        return conditionPmForm;
      }

      const conditionReopen = formStatus.value.isRejected
      const userCanReopen   = vm.$can('reopen', 'Trainings');
      const userOwnerValidationForm = (form.value.lastStatus && form.value.lastStatus.id_user_validation === user.id);

      return (conditionReopen && userCanReopen && userOwnerValidationForm);
    });

    const showExistingFiles = computed(() => (formStatus.value.isReview || formStatus.value.isApproved || formStatus.value.inProgress));

    const showExistingFilesEdit = computed(() => (formStatus.value.isReopen || formStatus.value.inProgress));

    const showValidateButtons = computed(() => {
      const formCondition  = formStatus.value.isReview;
      const userCanVlidate = vm.$can('validate', 'Trainings');
      const userOwnerValidationForm = (form.value.lastStatus && form.value.lastStatus.id_user_validation === user.id);

      return (formCondition && userCanVlidate && userOwnerValidationForm);
    });
    const showSaveButton = computed(() => {
      const disabledByStatuses = (formStatus.value.isReview || formStatus.value.isRejected || formStatus.value.isApproved || formStatus.value.isCanceled);
      const userCanCreate      = vm.$can('create', 'Trainings');
      const userCanUpdate      = vm.$can('update', 'Trainings');

      if (disabledByStatuses) {
        return false;
      } else if (formId.value) {
        return (userCanUpdate && !showAlert.value && (form.value.lastStatus && (user.id === form.value.lastStatus.id_user)));
      } else {
        return (!formStatus.value.withoutValue || formStatus.value.inProgress) && !showAlert.value && userCanCreate;
      }
    });

     //METHODS
    const filterUsers =(option, label, search) => {
      const text = search.toLowerCase()

      return (
        option.user?.toLowerCase().includes(text) ||
        option.full_name?.toLowerCase().includes(text)
      );
    }

    const getUserLabel = (option) => {
      return `${option.user} - ${option.full_name}`
    }

    return {
      form,
      isDark,
      formattedFacilityOptions,
      isFormDisabled,
      datePickerConfig,
      typeTrainingOptions,
      trainingModalityOptions,
      trainingTopicsOptions,
      formStatus,
      resultsOptions,
      validationComment,
      referenceShowed,
      existingFiles,
      userSelected,
      canUserSendToReview,
      userOptions,
      eventTypeOptions,
      currentFacilitySelected,
      files,
      formattedUserOptions,
      errors,
      onSearchFacility,
      goBackToList,
      addNewParticipant,
      removeParticipant,
      onChangeFacilitySelect,
      handleFileChange,
      removeFile,
      submitForm,
      removeExistingFile,
      sendToReview,
      showValidateButtons,
      approve,
      reject,
      showAlert,
      showSaveButton,
      userReopenedOptions,
      canUserSendToReopen,
      reopen,
      errorValidationComment,
      showExistingFiles,
      showExistingFilesEdit,
      onSearchByRems,
      onSearchUser,
      getStatusVariant,
      getStatusLabel,
      formatUser,
      getUserName,
      getUserEmail,
      formatDate,
      user,
      filterUsers,
      getUserLabel,
      disabledButton,
      userSelectedReasigned
    };
  },
};
</script>
<style lang="scss" scoped>
.timeNoBackground {
  border-radius: 0.3em;
  background-color: transparent;
  margin: 0;
  border-radius: 0.3em;
  border: 1px solid #cecece;
  background-color: transparent;
  padding: 0.75em;
  margin: 0;
}
.groupContainer {
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  padding: 5px;
  margin-bottom: 10px;
}
.text-error {
  color: #ec0303;
}
.form-container {
  height: calc(100vh - 150px);
  overflow: auto;
}

.comment-box {
  width: 450px;
}

/*info left, history right */
.header-grid {
  max-width: 850px;
}

@media (max-width: 992px) {
  .header-grid {
    grid-template-columns: 1fr;
  }
}

.info-card {
  background: #f9fafb;
  border: 1px solid #eceff3;
  border-radius: 8px;
  padding: 10px 12px;
}

.info-row {
  display: flex;
  gap: 6px;
  margin-bottom: 4px;
}

.info-label {
  font-weight: 600;
  color: #444;
}

.info-value {
  color: #111;
  text-transform: none !important;
}

.history-card { background: #fff; border: 1px solid #eceff3; border-radius: 8px; padding: 12px; overflow: hidden; min-width: 300px; }
.history-header { margin-bottom: 8px; }
.history-table { width: 100%; }
.history-row { display: grid;
  grid-template-columns: auto 1fr auto;
  column-gap: 8px;
  align-items: center;}
.history-row-item-container {
  border-bottom: 1px dotted #e0e0e0;
}
.history-row-item {  display: grid;
  grid-template-columns: auto 1fr auto;
  column-gap: 8px;
  align-items: center;
  padding: 10px 0;
}
.history-row-item__comments {
  font-size: 16px;
}
.history-row:last-child { border-bottom: 0; }
.history-row--head { border-bottom: 1px solid #e9ecef; font-weight: 600; color: #444; padding-top: 0; padding-bottom: 8px; }
.col-state { justify-self: start; }
.col-user { justify-self: start; min-width: 0; }
.col-date { justify-self: end; white-space: nowrap; overflow: visible; }
.history-row--head > div, .history-row > .col-user { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.col-note { white-space: normal; overflow: hidden; }
.history-badge { display: inline-flex; align-items: center; }
.history-date { font-size: 12px; color: #6c757d; font-variant-numeric: tabular-nums; }
.content-grid { display: block; }
</style>
